import type { IAssignmentRepository } from '@/core/domain/school/assignment/IAssignmentRepository'
import type { AssignmentForClassroom } from '@/core/domain/school/assignment/AssignmentForClassroom.ts'

/**
 * Use case pour récupérer les assignments valables pour une classe donnée
 */
export class FetchAssignmentsForClassroomUseCase {
  private readonly assignmentRepository: IAssignmentRepository

  constructor(assignmentRepository: IAssignmentRepository) {
    this.assignmentRepository = assignmentRepository
  }

  async execute(
    schoolId: number,
    periodId: number,
    classroomId: number
  ): Promise<AssignmentForClassroom | null> {
    return await this.assignmentRepository.fetchAssignmentsForClassroom(
      schoolId,
      periodId,
      classroomId
    )
  }
}
